import {
	getConfigFieldsCrud,
	getConfigVoucher,
	getTablePricesLists,
	getTablePricesListsAutocomplete,
	pricesListsUpdateApply,
	pricesListsUpdatePaginate,
	pricesListsUpdateRecord,
	selectSearchedProducts,
	voucherCancel
} from 'actions'
import CommonModal from 'components/common/commonModal'
import SearchProductsForm from 'components/SearchProducts/SearchProductsForm'
import SearchProductsTable from 'components/SearchProducts/SearchProductsTable'
import {
	P_PRICES_LISTS_MASSIVE_UPDATE,
	P_SEARCH_PRODUCTS
} from 'constants/ConfigProcessNames'
import { getFiltersData } from 'lib/Utils'
import {
	ActionType,
	ConfirmType,
	IActionChangeParams,
	IPricesListsMassiveUpdateDiscountFormProps,
	IPricesListsMassiveUpdateHeaderFormProps,
	IPricesListsMassiveUpdateListFormProps,
	IPricesListsMassiveUpdateProductFormProps,
	IPricesListsMassiveUpdateProps,
	IPricesListsMassiveUpdateState,
	IPricesListsUpdateApply,
	ISelectListValueParam
} from 'models/PricesListsMassiveUpdate'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { withRouter } from 'react-router-dom'
import { CRUD, CRUD_PRICES_LIST } from 'utils/RoutePath'
import PricesListsMassiveUpdateTable from '../PricesListsMassiveUpdate/PricesListsMassiveUpdateTable'
import PricesListsMassiveUpdateDiscountForm from './PricesListsMassiveUpdateDiscountForm'
import PricesListsMassiveUpdateHeaderForm from './PricesListsMassiveUpdateHeaderForm'
import PricesListsMassiveUpdateListForm from './PricesListsMassiveUpdateListForm'
import PricesListsMassiveUpdateProductForm from './PricesListsMassiveUpdateProductForm'

class PricesListsMassiveUpdate extends Component<
	IPricesListsMassiveUpdateProps & RouteComponentProps,
	IPricesListsMassiveUpdateState
> {
	constructor(props: IPricesListsMassiveUpdateProps & RouteComponentProps) {
		super(props)
		this.state = {
			showSearchModal: false,
			action: {
				code: '',
				text: ''
			},
			lk_sel_list: '',
			isSearching: false,
			showConfirmModal: false,
			idCliente: '',
			disableForm: false,
			errorMessage: '',
			searchParams: {
				filtro_desc_prod: '',
				filtro_desc_lp: '',
				filtro_desc_catprod: '',
				page_number: 1,
				page_size: 10,
				total_count: 0,
				idOperacion: 0
			}
		}
	}

	componentDidMount(): void {
		this.props.getConfigFieldsCrud({ cod_abm: P_SEARCH_PRODUCTS })
	}

	componentDidUpdate(
		prevProps: IPricesListsMassiveUpdateProps,
		prevState: IPricesListsMassiveUpdateState
	) {
		const { pricesListsUpdateRecorded, pricesListsUpdatePaginate } = this.props
		const { pricesListsUpdateRecorded: prevPricesListsUpdateRecorded } =
			prevProps

		const { searchParams } = this.state
		const { searchParams: prevSearchParams } = prevState

		if (
			prevPricesListsUpdateRecorded !== pricesListsUpdateRecorded &&
			pricesListsUpdateRecorded &&
			pricesListsUpdateRecorded.Resultado.Mens_error
		) {
			this.setState({
				errorMessage: pricesListsUpdateRecorded.Resultado.Mens_error,
				showConfirmModal: true
			})
		}

		if (searchParams !== prevSearchParams) {
			pricesListsUpdatePaginate(searchParams)
		}
	}

	handleCancelRedirect = () => {
		const { idOperacion, voucherCancel } = this.props
		voucherCancel({ idOperacion })
	}

	handleActionChange = (value: IActionChangeParams) => {
		this.setState({
			action: {
				code: value.codigo,
				text: value.descrip + ':  ' + value.texto
			}
		})
	}

	handleSelectListValue = (value: ISelectListValueParam) => {
		this.setState({
			lk_sel_list: value.codigo
		})
	}

	handleCloseSearchModal = () => {
		this.setState({ showSearchModal: false })
	}

	handleToggleSearchModal = () => {
		this.setState((state) => ({
			showSearchModal: !state.showSearchModal
		}))
	}

	// This function belongs to the search products modal, and values equals to a big object//
	handleSendSearch = (values: any) => {
		const { idOperacion, selectSearchedProducts } = this.props
		this.setState({ showSearchModal: false })
		selectSearchedProducts({ ...values, idOperacion })
	}

	handleSearchPricesLists = (copia_pc: String) => {
		const { getTablePricesListsAutocomplete } = this.props
		getTablePricesListsAutocomplete(copia_pc)
		this.handleIsSearching(true)
	}

	handleIsSearching = (isSearching: boolean) => {
		this.setState({ isSearching })
	}

	handleClientsPricesLists = (idCliente: String) => {
		this.props.getTablePricesLists(idCliente)
	}

	handlePricesListsApply = (values: IPricesListsUpdateApply) => {
		const { pricesListsUpdateApply, idOperacion } = this.props

		const newFilters = {
			...values,
			idOperacion: idOperacion || 0
		}

		pricesListsUpdateApply(newFilters)
	}

	handlePricesListsRecord = (confirm: ConfirmType, action: ActionType) => {
		const { pricesListsUpdateRecord, idOperacion } = this.props

		const newValues = {
			accion: action,
			confirmar: confirm,
			idOperacion: idOperacion || 0
		}

		pricesListsUpdateRecord(newValues)
	}

	handleRedirectPriceList = () => {
		const { history } = this.props
		history.push(`${CRUD}/${CRUD_PRICES_LIST}`)
	}

	handleConfirmModal = (showConfirmModal: boolean) => {
		this.setState({ showConfirmModal: showConfirmModal })
	}

	handleChangeTable = (type: String, pagination: any, value: any) => {
		const { idOperacion } = this.props
		const { searchParams } = this.state
		if (type === 'pagination') {
			this.setState({
				searchParams: {
					...searchParams,
					idOperacion: idOperacion || 0,
					page_number: pagination.page,
					page_size: pagination.sizePerPage
				}
			})
		} else if (type === 'filter') {
			const filtro_desc_catprod =
				pagination.filters?.desc_catprod?.filterVal || ''
			const filtro_desc_lp = pagination.filters?.desc_lp?.filterVal || ''
			const filtro_desc_prod = pagination.filters?.desc_prod?.filterVal || ''

			this.setState({
				searchParams: {
					...searchParams,
					idOperacion: idOperacion || 0,
					page_number: pagination.page,
					page_size: pagination.sizePerPage,
					filtro_desc_catprod: filtro_desc_catprod,
					filtro_desc_lp: filtro_desc_lp,
					filtro_desc_prod: filtro_desc_prod
				}
			})
		}
	}

	renderSearchProducts = () => {
		const { fieldsConfig } = this.props
		return (
			<>
				<SearchProductsForm
					fields={getFiltersData(fieldsConfig.campos, {
						agrupador: 'formulario'
					})}
					isSearchProducts={true}
					handleSendSearch={this.handleSendSearch}
				/>
				<SearchProductsTable
					fields={getFiltersData(fieldsConfig.campos, {
						agrupador: 'grilla'
					})}
				/>
			</>
		)
	}

	render() {
		const {
			t,
			config,
			idOperacion,
			selectedProducts,
			listsAutocomplete,
			pricesLists,
			gridProducts,
			gridFilters
		} = this.props

		const {
			showSearchModal,
			action,
			errorMessage,
			lk_sel_list,
			disableForm,
			showConfirmModal,
			isSearching
		} = this.state

		const arrayFilters = [
			{
				idFilter: 'desc_catprod',
				values: gridFilters?.filtro_desc_catprod || []
			},
			{ idFilter: 'desc_lp', values: gridFilters?.filtro_desc_lp || [] },
			{ idFilter: 'desc_prod', values: gridFilters?.filtro_desc_prod || [] }
		]

		const tableFields = config
			? getFiltersData(config.campos, { agrupador: 'grilla' })
			: []
		const headerFormFields = config
			? getFiltersData(config.campos, { agrupador: 'header' })
			: []
		const productFormFields = config
			? getFiltersData(config.campos, { agrupador: 'producto' })
			: []
		const listFormFields = config
			? getFiltersData(config.campos, { agrupador: 'lista' })
			: []
		const discountFormFields = config
			? getFiltersData(config.campos, { agrupador: 'descuento' })
			: []

		const headerFormProps: IPricesListsMassiveUpdateHeaderFormProps = {
			fields: headerFormFields,
			handleActionChange: this.handleActionChange
		}

		const productFormProps: IPricesListsMassiveUpdateProductFormProps = {
			fields: productFormFields,
			handleOpenModal: this.handleToggleSearchModal,
			selectedProducts: selectedProducts,
			action: action
		}

		const listFormProps: IPricesListsMassiveUpdateListFormProps = {
			fields: listFormFields,
			idOperacion: idOperacion || 0,
			handleClientsPricesLists: this.handleClientsPricesLists,
			handleRedirectPriceList: this.handleRedirectPriceList,
			handleSelectListValue: this.handleSelectListValue,
			pricesLists: pricesLists
		}

		const discountFormProps: IPricesListsMassiveUpdateDiscountFormProps = {
			fields: discountFormFields,
			idOperacion: idOperacion || 0,
			disableForm: disableForm,
			actionCode: action.code,
			handleIsSearching: this.handleIsSearching,
			handleSearchPricesLists: this.handleSearchPricesLists,
			handlePricesListsRecord: this.handlePricesListsRecord,
			handlePricesListsApply: this.handlePricesListsApply,
			handleConfirmModal: this.handleConfirmModal,
			handleCancelRedirect: this.handleCancelRedirect,
			showConfirmModal: showConfirmModal,
			isSearching: isSearching,
			listsAutocomplete: listsAutocomplete,
			errorMessage: errorMessage,
			action: action,
			lk_sel_list: lk_sel_list
		}

		const tableProps = {
			tableFields: tableFields,
			fields: gridProducts,
			t: t,
			disableForm: false,
			handleChangeTable: this.handleChangeTable,
			gridFilters: arrayFilters
		}
		const propsSearchModal = {
			showModal: showSearchModal,
			handleCloseModal: this.handleToggleSearchModal,
			modalTitle: 'Busqueda de productos',
			modalBody: showSearchModal ? this.renderSearchProducts() : <></>,
			buttons: false,
			sizeModal: 'xl'
		}

		return (
			<>
				<PricesListsMassiveUpdateHeaderForm {...headerFormProps} />
				<PricesListsMassiveUpdateProductForm {...productFormProps} />
				{showSearchModal && <CommonModal {...propsSearchModal} />}
				<PricesListsMassiveUpdateListForm {...listFormProps} />
				<PricesListsMassiveUpdateDiscountForm {...discountFormProps} />
				<PricesListsMassiveUpdateTable {...tableProps} />
			</>
		)
	}
}
const mapStateToProps = ({
	voucher,
	auth,
	configCrud,
	tableCalls,
	pricesListsMassiveUpdate,
	searchProducts
}: any) => {
	const config = voucher.config
		? voucher.config[P_PRICES_LISTS_MASSIVE_UPDATE]
		: null

	const { fieldsConfig } = configCrud
	const { selectedProducts } = searchProducts
	const { listsAutocomplete, pricesLists } = tableCalls
	const { pricesListsUpdateRecorded, gridProducts, gridFilters } =
		pricesListsMassiveUpdate

	return {
		config,
		fieldsConfig,
		selectedProducts,
		listsAutocomplete,
		gridFilters,
		pricesLists,
		gridProducts,
		pricesListsUpdateRecorded
	}
}

const connectForm = connect(mapStateToProps, {
	getConfigVoucher,
	getConfigFieldsCrud,
	getTablePricesListsAutocomplete,
	getTablePricesLists,
	selectSearchedProducts,
	pricesListsUpdateRecord,
	pricesListsUpdateApply,
	pricesListsUpdatePaginate,
	voucherCancel
})(PricesListsMassiveUpdate)
export default withTranslation()(withRouter(connectForm))
